<template>
  <div class="my-nav" id="home">
    <b-container>
      <b-navbar toggleable="lg">
        <b-navbar-brand class="brand">
          <a href="#app">
            <img src="/logo-transparent.png" />
          </a>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" id="white-color"></b-navbar-toggle>

        <!-- Right aligned nav items -->
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="#app">Acasa</b-nav-item>
            <b-nav-item href="#nav-despre">Despre noi</b-nav-item>
            <b-nav-item href="#nav-hamace">Hamace</b-nav-item>
            <b-nav-item href="#nav-contact">Contact</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style>
.brand {
  display: flex;
  align-items: center;
}

.navbar-light .navbar-nav a.nav-link {
  font-size: 16px;
  font-weight: 600;
}

nav.navbar.navbar-light.navbar-expand-lg {
  padding: 10px 0px;
}

.my-nav {
  width: 100%;
  position: fixed;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 200;
  background-color: #fdfdfd;
}

.my-nav img {
  width: 100px;
  position: relative;
  float: left;
}
</style>
